import { Box, Container, Grid, Typography } from "@mui/material";
import { designTokens } from "../../../theme/designTokens";
import { journeyTimeline } from "../../../theme/aboutContent";

const { colors, spacing } = designTokens;

const CompanyHistorySection = () => (
  <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: colors.white }}>
    <Container maxWidth={spacing.containerMax}>
      <Typography
        component="h2"
        sx={{
          fontWeight: 900,
          fontSize: { xs: "2rem", md: "3rem" },
          lineHeight: { xs: 1.3, md: "60px" },
          textAlign: "center",
          color: colors.textPrimary,
          mb: { xs: 6, md: 10 },
        }}
      >
        Our Journey Through the
        <br />
        Years
      </Typography>

      <Box sx={{ position: "relative", maxWidth: 1100, mx: "auto" }}>
        <Box
          sx={{
            display: { xs: "none", md: "block" },
            position: "absolute",
            left: "50%",
            top: 0,
            bottom: 0,
            width: 2,
            backgroundColor: "#D9D9D9",
            transform: "translateX(-50%)",
            zIndex: 0,
          }}
        />

        <Box sx={{ display: "flex", flexDirection: "column", gap: { xs: 6, md: 10 } }}>
          {journeyTimeline.map((entry) => (
            <Box key={entry.year} sx={{ position: "relative" }}>
              <Box
                sx={{
                  display: { xs: "flex", md: "none" },
                  alignItems: "center",
                  gap: 2,
                  mb: 2,
                }}
              >
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    backgroundColor: colors.primary,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 0px 13px rgba(227,24,55,0.55)",
                    flexShrink: 0,
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 900,
                      fontSize: "0.9375rem",
                      color: colors.white,
                      lineHeight: 1,
                    }}
                  >
                    {entry.year}
                  </Typography>
                </Box>
              </Box>

              <Grid
                container
                spacing={{ xs: 3, md: 4 }}
                alignItems="center"
                direction={entry.imageOnLeft ? "row" : "row-reverse"}
              >
                <Grid item xs={12} md={5}>
                  <Box
                    sx={{
                      borderRadius: "16px",
                      overflow: "hidden",
                      boxShadow: "0px 25px 50px -12px rgba(0,0,0,0.25)",
                    }}
                  >
                    <Box
                      component="img"
                      src={entry.image}
                      alt={entry.imageAlt}
                      sx={{
                        width: "100%",
                        height: { xs: 200, md: 208 },
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={2}
                  sx={{
                    display: { xs: "none", md: "flex" },
                    justifyContent: "center",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: "50%",
                      backgroundColor: colors.primary,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0px 0px 13px rgba(227,24,55,0.55)",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 900,
                        fontSize: "0.9375rem",
                        color: colors.white,
                        lineHeight: 1,
                      }}
                    >
                      {entry.year}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} md={5}>
                  <Box sx={{ px: { md: entry.imageOnLeft ? 0 : 2 } }}>
                    <Typography
                      sx={{
                        fontWeight: 900,
                        fontSize: "1.5rem",
                        lineHeight: "32px",
                        color: colors.primary,
                        mb: 1.5,
                      }}
                    >
                      {entry.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        lineHeight: "22.75px",
                        color: colors.primary,
                      }}
                    >
                      {entry.description}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Box>
      </Box>
    </Container>
  </Box>
);

export default CompanyHistorySection;
